import { render, staticRenderFns } from "./complexTable.vue?vue&type=template&id=03c90dc4&"
import script from "./complexTable.vue?vue&type=script&lang=js&"
export * from "./complexTable.vue?vue&type=script&lang=js&"
import style0 from "./complexTable.vue?vue&type=style&index=0&id=03c90dc4&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports